import React, { Component } from "react";
import { View, Image, Text, SafeAreaView, Platform } from "react-native";
import styles from "./styles.js";
import textConstants from "../../constants/textConstants";
import HocComponent from "../../commonComponents/Hoc.js";
import TimerMessage from "../../commonComponents/TimerMessage";
import CommonButton from "../../commonComponents/Button";
import { HOME } from "../../constants/routePaths.native";


// successful payment screen UI
class PaymentFailedScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_room: "",
    };
  }
  onClickCloseButton = () => {
    if (Platform.OS == "web") {
    } else {
      this.props.navigation.navigate(HOME, {});
    }
  };
  closeWindow = () => {
    window.close();
  };

  //function to redirection for whatsapp
  redirectToWhatsapp = () => {
    window.open(this.props.location.state.redirect, '_self')
  }
  componentDidMount() {
    if (Platform.OS === "web") {
      if (this.props.location.state && this.props.location.state.redirect) {
        setTimeout(this.redirectToWhatsapp, 5000);
      }
      // closing Tab 5 seconds
      else {
        setTimeout(this.closeWindow, 5000);
      }
    }
  }
  // UI rendering
  render() {
    return (
      <SafeAreaView style={styles.safeAreaViewStyle}>
        <View style={styles.successContainer}>
          <Image
            style={styles.successLogo}
            source={require("../../../assets/images/successPic.webp")}
          ></Image>

          <Text style={styles.paymentSuccessHead}>
            {textConstants.paymentFailed}
          </Text>
          {Platform.OS == "web" && <TimerMessage />}
          {Platform.OS != "web" && (
            <View>
              <CommonButton
                onPress={() => this.onClickCloseButton()}
                ButtonText={"Close"}
              />
            </View>
          )}

          {/* <Text style={styles.paymentSuccessSubText}>
            {textConstants.finalSuccessMessage}
            {textConstants.finalThankyouMessage}
          </Text> */}
        </View>
      </SafeAreaView>
    );
  }
}
export default HocComponent(PaymentFailedScreen);
